import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { ACTIVE } from '../../../../constants/productStatuses';
import { useForm } from '../../../../utils/customHooks/use-form';
import { SingleProduct } from '../SingleProduct/single-product';
import { ProductListElement } from '../../../../components/ProductListElement/product-list-element';
import DeviceScannerContainer from 'modules/DeviceScanner/DeviceActivationScannerContainer';
import { useProductActions } from 'modules/CustomerProducts/api';
import { Modal } from 'components/modal';
import styled from 'styled-components';
import { PurPurButton } from 'components';
import spacing from 'theme/spacing';
const StyledButtonContainer = styled.div `
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;
const StyledButtonWrapper = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing.spacing16};
`;
const ProductListElementContainer = ({ product, customerId, languageStrings, }) => {
    const { canBeRemoved, devices, linkOptions, name, status, productId } = product;
    const { activateAgreement, activateWithSerials, deleteProduct, errors, isProductFetching, clearActivationFieldError, } = useProductActions(customerId, productId, product.agreementDetailId);
    const [showScanner, setShowScanner] = useState(false);
    const [showProductFullscreen, setShowProductFullscreen] = useState(false);
    const [activatedAnimation, setActivatedAnimation] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const onSubmit = (formValues) => {
        // Only try to activate when all serialNumbers are present
        const missingCount = devices.filter(device => !device.serialNumber).length;
        const providedCount = Object.values(formValues).filter(Boolean).length;
        if (missingCount !== providedCount)
            return;
        const body = Object.entries(formValues).map(([key, value]) => ({
            dpadId: Number(key),
            serialNumbers: [value],
        }));
        activateWithSerials(body);
        setActivatedAnimation(true);
    };
    const { values, handleChange, handleSubmit, overrideValue } = useForm(() => onSubmit(values));
    const handleInputChange = (e) => {
        const dpadId = Number(e.target.name);
        if (!Number.isNaN(dpadId)) {
            clearActivationFieldError(dpadId);
        }
        handleChange(e);
    };
    const onReset = (dpadId) => {
        overrideValue(String(dpadId), '');
        clearActivationFieldError(dpadId);
    };
    const onSerialNumberFound = (serialNumbers) => {
        serialNumbers.forEach((sn, index) => {
            var _a;
            const dpadId = (_a = devices[index]) === null || _a === void 0 ? void 0 : _a.dpadId;
            if (typeof dpadId === 'number') {
                overrideValue(String(dpadId), sn.serialNumber);
                clearActivationFieldError(dpadId);
            }
        });
    };
    const missingSerialNumbers = useMemo(() => devices
        .filter(device => !device.serialNumber)
        .map(device => {
        var _a, _b;
        return ({
            dpadId: device.dpadId,
            value: (_a = values[String(device.dpadId)]) !== null && _a !== void 0 ? _a : '',
            errorMessage: (_b = errors.activationFieldMap.get(device.dpadId)) !== null && _b !== void 0 ? _b : '',
        });
    }), [devices, values, errors.activationFieldMap]);
    const clickable = status === ACTIVE && (devices.length > 0 || linkOptions.length > 0);
    const canBeActivated = status !== ACTIVE && !missingSerialNumbers.length;
    const onActivate = () => {
        activateAgreement();
        setActivatedAnimation(true);
    };
    return (_jsxs("div", { children: [_jsx(ProductListElement, { clickable: clickable, canBeActivated: canBeActivated, serialNumberInputs: missingSerialNumbers, onClick: () => setShowProductFullscreen(true), handleChange: handleInputChange, handleSubmit: handleSubmit, isFetching: isProductFetching, shouldActivateActiveAnimation: activatedAnimation, title: name, status: status, onActivate: onActivate, onDelete: () => setShowDeleteModal(true), errorMessage: errors.activateWithSerials ||
                    errors.activateAgreement ||
                    errors.delete ||
                    errors.swapDeviceSerial, showDeleteButton: canBeRemoved && !clickable, onScannerClick: () => setShowProductFullscreen(true), serialNumbers: devices.map(device => device.serialNumber), onReset: onReset, showLinkIcon: linkOptions.length > 0 }), showScanner && (_jsx(DeviceScannerContainer, { onClose: () => setShowScanner(false), dpadIdsToActivate: missingSerialNumbers.map(device => device.dpadId), productId: productId, customerId: customerId, onActivation: () => setActivatedAnimation(true), onSerialNumberFound: onSerialNumberFound })), _jsx(SingleProduct, { product: product, customerId: customerId, display: showProductFullscreen, close: () => setShowProductFullscreen(false) }), showDeleteModal && (_jsx(Modal, { isOpen: showDeleteModal, title: languageStrings.REMOVE_PRODUCT_POPUP.REMOVE_PRODUCT, onClose: () => setShowDeleteModal(false), actionButtons: _jsxs(StyledButtonContainer, { children: [_jsx(StyledButtonWrapper, { children: _jsx(PurPurButton, { size: "sm", type: "button", variant: "secondary", onClick: () => setShowDeleteModal(false), children: languageStrings.REMOVE_PRODUCT_POPUP.CANCEL }) }), _jsx(StyledButtonWrapper, { children: _jsx(PurPurButton, { size: "sm", type: "button", variant: "destructive", onClick: () => {
                                    deleteProduct();
                                    setShowDeleteModal(false);
                                }, children: languageStrings.REMOVE_PRODUCT_POPUP.REMOVE }) })] }), children: languageStrings.REMOVE_PRODUCT_POPUP.REMOVE_PRODUCT_QUESTION }))] }));
};
const mapStateToProps = (state) => ({
    languageStrings: state.NOB,
});
export default connect(mapStateToProps)(ProductListElementContainer);
